module.exports = __webpack_public_path__ + "img/mc.01bcdb6a.svg";